import { Component, HostListener, Input } from '@angular/core';

@Component({
  selector: 'app-our-projects',
  templateUrl: './our-projects.component.html',
  styleUrls: ['./our-projects.component.css'],
})
export class OurProjectsComponent {
  @Input() data!: any;
  @Input() fileName!: string;
  @Input() language!: string;

  groupedServices: any[] = [];
  private currentChunkSize = 0;

  ngOnInit(): void {
    this.updateGroupedServices();
  }

  groupArray<T>(arr: T[], chunkSize: number): T[][] {
    const result: T[][] = [];
    for (let i = 0; i < arr.length; i += chunkSize) {
      result.push(arr.slice(i, i + chunkSize));
    }
    return result;
  }

  updateGroupedServices(): void {
    const width = window.innerWidth;
    let chunkSize = 1;

    if (width >= 992) {
      chunkSize = 4;
    } else if (width >= 768) {
      chunkSize = 2;
    } else if (width >= 576) {
      chunkSize = 1;
    }

    if (chunkSize !== this.currentChunkSize) {
      this.groupedServices = this.groupArray(this.data.details.services, chunkSize);
      this.currentChunkSize = chunkSize;
    }
  }

  @HostListener('window:resize')
  onResize(): void {
    this.updateGroupedServices();
  }

  getDetailsUrl(obj: any): string {
    return `/${this.language}/details/${this.fileName}/${obj.title.replaceAll(' ', '-').toLowerCase()}`;
  }
}
